import { cn } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import { BrandMark } from "@apps/dashboard/components/brand/BrandMark";

/**
 * Composición tipo variación 02: isotipo + nombre + eslogan (bienvenida / auth).
 */
export function BrandAuthHero({
  className,
  showSlogan = true,
  showTitle = true,
}: {
  className?: string;
  showSlogan?: boolean;
  showTitle?: boolean;
}): JSX.Element {
  const { t } = useI18n();
  return (
    <div className={cn("text-center", className)}>
      <BrandMark className="mx-auto mb-5 size-[4.5rem]" />
      {showTitle ? (
        <h1 className="font-headline text-3xl font-extrabold tracking-tight text-primary sm:text-4xl">
          {t("dashboardUi.auth.appName")}
        </h1>
      ) : null}
      {showSlogan ? (
        <p
          className={cn(
            "mx-auto max-w-md whitespace-pre-line font-headline text-base font-semibold leading-relaxed text-on-secondary-container",
            showTitle ? "mt-4" : "mt-0",
          )}
        >
          {t("dashboardUi.shell.brandSlogan")}
        </p>
      ) : null}
    </div>
  );
}
